import { SelectItem } from 'primeng/api';
import { Direction } from '../models/direction.enum';
import { AuthorityPoint } from '../models/authoritypoint';
import { AuthorityPointGroup } from "../models/authoritypointgroup";
import { EntryLocation } from '../models/entrylocation';

export class LineItemModel {

    operatingFrom: AuthorityPointGroup = null;
    operatingTo: AuthorityPointGroup = null;
    selectedTrackFrom: AuthorityPoint = null;
    selectedTrackTo: AuthorityPoint = null;
    selectedDirection: Direction = null;

    errorMessageOperatingFrom: string = null;
    errorMessageOperatingTo: string = null;
    errorMessageSelectedTrackFrom: string = null;
    errorMessageSelectedTrackTo: string = null;
    errorMessageSelectedDirection: string = null;

    isValid(): boolean {
        let status: boolean = true;
        this.errorMessageOperatingFrom = null;
        this.errorMessageOperatingTo = null;
        this.errorMessageSelectedTrackFrom = null;
        this.errorMessageSelectedTrackTo = null;
        this.errorMessageSelectedDirection = null;

        //Validate 
        if (this.operatingFrom === null) {
            this.errorMessageOperatingFrom = "Required";
            status = false;
        } else if (typeof this.operatingFrom === 'string' || this.operatingFrom instanceof String) {
            this.errorMessageOperatingFrom = LineItemModel.validateStringAuthorityPoint(this.operatingFrom + "");
            status = this.errorMessageOperatingFrom === null;
        }
        if (this.operatingTo === null) {
            this.errorMessageOperatingTo = "Required";
            status = false;
        } else if (typeof this.operatingTo === 'string' || this.operatingTo instanceof String) {
            this.errorMessageOperatingTo = LineItemModel.validateStringAuthorityPoint(this.operatingTo + "");
            status = this.errorMessageOperatingTo === null;
        }
        if (Direction[this.selectedDirection] === null) {
            this.selectedDirection = null;
        }
        if (this.selectedDirection === null) {
            this.errorMessageSelectedDirection = "Required"
            status = false;
        }
        if (this.selectedTrackFrom === null) {
            this.errorMessageSelectedTrackFrom = "Required"
            status = false;
        }

        if (this.selectedTrackTo === null) {
            this.errorMessageSelectedTrackTo = "Required"
            status = false;
        }
        return status;
    }

    isDirty(): boolean {
        return this.operatingFrom != null || this.operatingTo != null || this.selectedDirection != null || this.selectedTrackFrom != null || this.selectedTrackTo != null;
    }

    static validateStringAuthorityPoint(subject: string): string {
        let errorMessage: string = LineItemModel.validateCombinedPrefixMilepostPattern(subject);
        return errorMessage;
    }
    static validateCombinedPrefixMilepostPattern(combinedPrefixMilepost: string): string {
        // Format: alphanumeric prefix + single space + integer milepost with optional tenth precision.
        let pattern = new RegExp(/^[a-zA-Z0-9]+ [0-9]+(\.[0-9])?$/);
        if (combinedPrefixMilepost === null || !pattern.test(combinedPrefixMilepost)) {
            return "Prefix Milepost format not valid";
        }
        return null;
    }
}